document.addEventListener('DOMContentLoaded', (e) => {
	//console.log('converts script');
	// simple tabs show/hide
	jQuery("#tab-us").click(function(e){
		e.preventDefault();
		jQuery('.view-display-id-block_us').triggerHandler('RefreshView'); // trigger View block refresh
		jQuery("#tab-eu").removeClass("selected");
		jQuery(this).addClass("selected");
		jQuery("#grid-tab-us").show();
		jQuery("#grid-tab-eu").hide();
	});

	jQuery("#tab-eu").click(function(e){
		e.preventDefault();
		jQuery('.view-display-id-block_euro').triggerHandler('RefreshView'); // trigger View block refresh
		jQuery("#tab-us").removeClass("selected");
		jQuery(this).addClass("selected");
		jQuery("#grid-tab-us").hide();
		jQuery("#grid-tab-eu").show();
	});

	jQuery(".view-extremist-converts-grid .views-field-field-extremist-image a").click(function(e){
		e.preventDefault();
	});
});
